import { ServerPricing, TimesPrice } from '../types';

export const transformServerTimePricing = (req: TimesPrice = []): ServerPricing => {
  const serverPricing: ServerPricing = {};
  req.forEach(({ startTime, endTime, price }) => {
    let currentTime = startTime;
    while (currentTime < endTime) {
      serverPricing[currentTime] = price;
      ++currentTime;
    }
  });
  return serverPricing;
};

export const transformTimesPriceToTable = (timesPrice: TimesPrice) => (timesPrice.map((timePrice) => ({
  ...timePrice,
  key: Number(timePrice.startTime + timePrice.endTime + timePrice.price)
})));
